import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { TransitAdminDto } from '../models/transit-admin.model';


@Injectable({ providedIn: 'root' })
export class TransitAdminService {

    constructor(private http: HttpServices) {
    }

    AddMarineAcceptance(data: TransitAdminDto) {
        return this.http.post('Transit/AddMarineAcceptance', data);
    }
    treasuryFirstConfirmPayment(data: TransitAdminDto) {
        return this.http.post('Transit/TreasuryFirstConfirmation', data);
    }
    vesselArrived(data: TransitAdminDto) {
        return this.http.post('Transit/MarkVesselArrived', data);
    }

    checkDuplicateChequeNumber(chequeNumber: string) {
        return this.http.get('Transit/CheckChequeNumber?chequeNumber=' + chequeNumber);
    }
    measurementDecisionTransit(data: TransitAdminDto) {
        return this.http.post('Transit/measurementDecisionTransit', data);
    }
    treasuryFinalConfirmPayment(data: TransitAdminDto) {
        return this.http.post('Transit/TreasuryFinalConfirmation', data);
    }
    confirmPendingDocuments(data: TransitAdminDto) {
        return this.http.post('Transit/ConfirmPendingDocuments', data);
    }
}